module.exports = __webpack_public_path__ + "images/emoji/calendar.c996642407fb91f497a7.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/calendar.png
// module id = LvAf
// module chunks = 24